import React from "react";

export default class StatusLegend extends React.Component {
    render() {
        //let names = {};

        // const statuses = this.props.objects.data.map(obj => {
        //     names[obj.status] = obj.status_name;
        //     return obj.status;
        // }).reduce((p, c) => {
        //     if (p.indexOf(c) < 0) p.push(c);
        //     return p;
        // }, []).sort();

        // const statuses = this.props.objects.data.map(obj => {
        //     names[obj.status] = obj.status_name;
        //     return obj.status;
        // }).sort();

        // const items = statuses.map((status) => {
        //     return (
        //         <li key={status}><span className={`status-blob status-blob-${status}`}></span> {names[status]}</li>
        //     )
        // });

        // return (
        //     <div className="cw-status-legend">
        //         <ul>
        //             {items}
        //         </ul>
        //     </div>);

        return (
            <div className="cw-status-legend">
                <ul>
                    <li key="ForSale"><span className={`status-blob status-blob-ForSale`}></span> Ledig</li>
                    <li key="Reserved"><span className={`status-blob status-blob-Reserved`}></span> Reserverad</li>
                    <li key="Sold"><span className={`status-blob status-blob-Sold`}></span> Såld</li>
                </ul>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/StatusLegend.jsx